import {AsyncTypeahead} from 'react-bootstrap-typeahead'
import {Button, ButtonGroup, Col, Form, Row} from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {BrowserView, MobileView} from 'react-device-detect'
import Dropdown from 'react-bootstrap/Dropdown'
import {Link, useLocation} from 'react-router'
import Alert from 'react-bootstrap/Alert'

import AlertCustom from '../../ui/alert/AlertCustom'
import AuthContext from '../../../contexts/AuthContext'
import ClientsAPI from '../../../services/ClientsAPI'
import ClientsFilters from './ClientsFilters'
import Field from '../../ui/form/Field'
import Loader from '../../ui/loader/Loader'
import ModalCustom from '../../ui/modal/ModalCustom'
import Title from '../../ui/page/Title'
import useFetch from '../../../hooks/useFetch'
import MagasinMenu from '../magasin/MagasinMenu'
import {ClientsContent} from './ClientsContent.tsx'
import Box from '../../ui/box/Box'

const Clients = () => {
    const [currentTab, setCurrentTab] = useState('clients');

    return (
        <>
            <Title title={'Mon magasin'} />
            <Box
                boxName={'magasin'}
                boxClassNames={'flex-column'}
                header={true}
                headerClassNames={'rounded-top'}
                boxContentBg={'white'}
                headerContent={
                    <>
                        <MagasinMenu currentTab={currentTab} setCurrentTab={setCurrentTab}/>
                    </>
                }
                content={<ClientsContent />}
            />
        </>
    );
}

export default Clients
